import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { provideRouter, RouterModule, withEnabledBlockingInitialNavigation } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { AgrNotificationEmptyModule, AgrPageSidesheetModule, AgrPageToolbarModule, AgrPrimaryActionModule } from '@next/core-lib/components';
import { FormDialogComponent, provideAgrDialog } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { provideAgrSettings } from '@next/core-lib/settings';
import { AgrSharedModule } from '@next/core-lib/shared';
import { SiteEffects } from '@next/core-lib/site';
import { AgrTableModule } from '@next/core-lib/table';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { CropVarietySpecificNormDialogComponent } from './components/crop-variety-specific-norm/dialog/crop-variety-specific-norm-dialog.component';
import { CropVarietySpecificNormListComponent } from './components/crop-variety-specific-norm/list/crop-variety-specific-norm-list.component';
import { ImportComponent } from './components/import/import.component';
import { ImportPhosphateLegalNormComponent } from './components/import-phosphate-legal-norm/import-phosphate-legal-norm.component';
/* eslint-disable-next-line max-len */
import { LegalNitrogenWorkingCoefficientDialogComponent } from './components/legal-nitrogen-working-coefficient/dialog/legal-nitrogen-working-coefficient-dialog.component';
/* eslint-disable-next-line max-len */
import { LegalNitrogenWorkingCoefficientListComponent } from './components/legal-nitrogen-working-coefficient/list/legal-nitrogen-working-coefficient-list.component';
import { PhosphateLegalNormDialogComponent } from './components/phosphate-legal-norm/dialog/phosphate-legal-norm-dialog.component';
import { PhosphateLegalNormListComponent } from './components/phosphate-legal-norm/list/phosphate-legal-norm-list.component';
// eslint-disable-next-line max-len
import { PhosphateLegalWorkingCoefficientDialogComponent } from './components/phosphate-legal-working-coefficient/dialog/phosphate-legal-working-coefficient-dialog.component';
/* eslint-disable-next-line max-len */
import { PhosphateLegalWorkingCoefficientListComponent } from './components/phosphate-legal-working-coefficient/list/phosphate-legal-working-coefficient-list.component';
import { ReportsComponent } from './components/reports/reports.component';
import { TotalNitrogenLegalNormDialogComponent } from './components/total-nitrogen-legal-norm/dialog/total-nitrogen-legal-norm-dialog.component';
import { TotalNitrogenLegalNormListComponent } from './components/total-nitrogen-legal-norm/list/total-nitrogen-legal-norm-list.component';
import { YearFilterComponent } from './components/year-filter/year-filter.component';
import { DisplayService } from './shared/services/display.service';
import { DownloadBlobService } from './shared/services/download-blob.service';
import { ImportService } from './shared/services/import.service';
import { cropVarietySpecificNormReducer } from './store/cropVarietySpecificNorm.reducer';
import { AppEffects } from './store/effects';
import { legalNitrogenWorkingCoefficientsReducer } from './store/legalNitrogenWorkingCoefficient.reducer';
import { phosphateLegalNormReducer } from './store/phosphateLegalNorm.reducer';
import { phosphateLegalWorkingCoefficientsReducer } from './store/phosphateLegalWorkingCoefficient.reducer';
import { appReducer } from './store/reducer';
import { totalNitrogenLegalNormReducer } from './store/totalNitrogenLegalNorm.reducer';

@NgModule({
  declarations: [
    AppComponent,
    ReportsComponent,
    YearFilterComponent,
    ImportPhosphateLegalNormComponent,
    ImportComponent,
    TotalNitrogenLegalNormListComponent,
    TotalNitrogenLegalNormDialogComponent,
    LegalNitrogenWorkingCoefficientListComponent,
    LegalNitrogenWorkingCoefficientDialogComponent,
    CropVarietySpecificNormListComponent,
    CropVarietySpecificNormDialogComponent,
    PhosphateLegalNormListComponent,
    PhosphateLegalNormDialogComponent,
    PhosphateLegalWorkingCoefficientListComponent,
    PhosphateLegalWorkingCoefficientDialogComponent,
  ],
  imports: [
    RouterModule,
    ReactiveFormsModule,
    CommonModule,
    AgrSharedModule,
    AgrWrapperSiteSidenavModule,
    AgrPageToolbarModule,
    AgrPrimaryActionModule,
    AgrPageSidesheetModule,
    AgrNotificationEmptyModule,
    AgrFormModule,
    FormDialogComponent,
    AgrPageToolbarModule,
    AgrTableModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatDialogModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatToolbarModule,
    MatChipsModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule,
  ],
  providers: [
    DownloadBlobService,
    ImportService,
    DisplayService,
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrSettings(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),
    provideEffects(),
    provideState('app', appReducer),
    provideState('totalNitrogenLegalNorm', totalNitrogenLegalNormReducer),
    provideState('legalNitrogenWorkingCoefficient', legalNitrogenWorkingCoefficientsReducer),
    provideState('phosphateLegalWorkingCoefficient', phosphateLegalWorkingCoefficientsReducer),
    provideState('cropVarietySpecificNorm', cropVarietySpecificNormReducer),
    provideState('phosphateLegalNorm', phosphateLegalNormReducer),
    provideEffects(AppEffects),
    provideAgrDialog(),
  ],
})
export class AppModule {}
